<template>
  <div class="container">
    <div class="background" />
    <div class="row main">
      <template v-if="step===1">
        <div class="col-12">
          <img
            class="logo-img"
            src="/img/logo.png"
          >
        </div>
        <div class="col-1" />
        <div class="col-10 date-selection">
          <date-field
            :date="date"
            @updateDate="updateDate"
          />
          <cinema-button
            label="Potwierdź"
            @click="nextStep()"
          />
        </div>
        <div class="col-1" />
      </template>
      <template v-if="step===2">
        <div class="col-12">
          <img
            class="logo-img"
            src="/img/logo.png"
          >
        </div>
        <div class="col-12 time-settings">
          <h1 class="text-start mb-3">
            Ograniczenia
          </h1>
          <div class="cf-input-group mt-2">
            <label>Liczba filmów</label>
            <select
              v-model="moviesNumber"
              class="form-select"
            >
              <option :value="1">
                1
              </option>
              <option :value="2">
                2
              </option>
            </select>
          </div>
          <div class="cf-input-group mt-2">
            <label>Maksymalna długość przerwy</label>
            <input
              v-model="maxBreak"
              type="text"
              class="form-control"
              @focusin="$event.target.select()"
              @focusout="formatMaxBreak"
            >
          </div>
          <div class="constraints">
            <time-constraint
              v-for="(constraint, key) in timeConstraints"
              :key="key"
              :constraint-key="key"
              :constraint="constraint"
              @removeConstraint="removeConstraint"
            />
          </div>
          <cinema-button
            label="Dodaj ograniczenie"
            @click="addConstraint()"
          />
          <cinema-button
            label="Potwierdź"
            @click="nextStepClearConstraints()"
          />
        </div>
      </template>
      <template v-if="step===3">
        <div class="col-12">
          <img
            class="logo-img"
            src="/img/logo.png"
          >
        </div>
        <div class="col-12 movies-selection">
          <h1 class="text-start mb-3">
            Wybór filmów
          </h1>
          <Movie
            v-for="movie in films"
            :key="movie.id"
            :movie="movie"
            :selected-value="selectedMovies[movie.id]"
            @changeSelection="changeSelection"
          />
          <cinema-button
            label="Potwierdź"
            @click="nextStep()"
          />
        </div>
      </template>
      <template v-if="step===4">
        <div class="col-12">
          <img
            class="logo-img"
            src="/img/logo.png"
          >
        </div>
        <div class="col-12 movies-selection">
          <h1 class="text-start mb-3">
            Wybór filmów
          </h1>
          <div>
            <Result
              v-for="(pair,index) in result"
              :key="index"
              :pair="pair"
              :titles="titles"
              class="margin-bottom"
            />
          </div>
          <cinema-button
            label="Od nowa"
            @click="step=1"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import DateField from '@/components/DateField'
import CinemaButton from '@/components/CinemaButton'
import TimeConstraint from '@/components/TimeConstraint'
import Movie from '@/components/Movie'
import axios from 'axios'
import Result from '@/components/Result'

function sortPair (a, b) {
  return a.movieBreak - b.movieBreak
}

export default {
  name: 'CinemaFinder',
  components: {
    Result,
    Movie,
    CinemaButton,
    DateField,
    TimeConstraint
  },
  data () {
    return {
      step: 1,
      maxBreak: '45 min',
      moviesNumber: 2,
      date: new Date().toISOString().split('T')[0],
      timeConstraints: [],
      films: [],
      selectedMovies: {},
      events: [],
      titles: []
    }
  },
  methods: {
    nextStep () {
      console.log(this.step)
      if (this.step === 1) {
        this.getMovies()
      }
      if (this.step === 3) {
        this.calculate()
      }
      this.step++
    },
    nextStepClearConstraints () {
      this.timeConstraints.forEach((constraint, key) => {
        if (constraint.removed === true) {
          this.timeConstraints.splice(key, 1)
        }
      })
      this.nextStep()
    },
    changeSelection (e) {
      console.log(this.selectedMovies)
      this.selectedMovies[e.movie] = e.value
    },
    getMovies: function () {
      const vm = this
      vm.result = []
      axios
        .get(vm.date + '.json')
        .then(response => {
          vm.films = response.data.body.films
          vm.events = response.data.body.events
          const selected = {}
          vm.films.forEach((movie) => {
            if (!vm.selectedMovies[movie.id]) {
              console.log(selected)
              selected[movie.id] = 0
            } else {
              selected[movie.id] = vm.selectedMovies[movie.id]
            }
          })
          vm.selectedMovies = selected
        })
    },
    formatMaxBreak () {
      console.log('format')
      this.maxBreak = parseInt(this.maxBreak) + ' min'
    },
    addConstraint () {
      this.timeConstraints.push({
        type: 0,
        start: '00:00',
        end: '23:59',
        removed: false
      })
    },
    removeConstraint (id) {
      this.timeConstraints[id].removed = true
    },
    calculate () {
      const vm = this
      vm.result = []
      let selected = null
      selected = []
      let events = null
      events = []
      let pairs = null
      pairs = []
      let titles = null
      titles = {}
      let lengths = null
      lengths = {}
      const required = []
      vm.films.forEach((movie) => {
        if (vm.selectedMovies[movie.id] === 2) {
          required.push(movie.id)
        }
      })
      vm.films.forEach(film => {
        titles[film.id] = film.name
        lengths[film.id] = film.length
      })
      this.films.forEach((film) => {
        if (this.selectedMovies[film.id]) {
          selected.push(film.id)
        }
      })
      this.events.forEach(event => {
        if (selected.includes(event.filmId)) {
          event.start = vm.calcDateToMins(event.eventDateTime)
          console.log(vm.minsToHour(event.start))
          event.end = vm.calcDateToMins(event.eventDateTime) + lengths[event.filmId] + 20
          console.log(vm.minsToHour(event.end))
          console.log(event.start)
          events.push(event)
        }
      })
      if (this.moviesNumber === 1) {
        events.forEach(event => {
          let ignore = false
          vm.timeConstraints.forEach(constraint => {
            if (constraint.type === 0) {
              if (constraint.end !== '23:59') {
                if (event.start > this.hourToMins(constraint.end)) {
                  ignore = true
                }
              }
              if (constraint.start !== '00:00') {
                if (event.start < this.hourToMins(constraint.start)) {
                  ignore = true
                }
              }
            }
            if (constraint.type === 1) {
              if (constraint.end !== '23:59') {
                if (event.end > this.hourToMins(constraint.end)) {
                  ignore = true
                }
              }
              if (constraint.start !== '00:00') {
                if (event.end < this.hourToMins(constraint.start)) {
                  ignore = true
                }
              }
            }
          })
          if (!ignore) {
            if (required.length > 0) {
              if (!required.includes(event.filmId)) {
                console.log('missing required')
                ignore = true
              }
            }
          }
          if (!ignore) {
            pairs.push({ event1: event, event2: null })
          }
        })
      } else if (this.moviesNumber === 2) {
        events.forEach(event1 => {
          events.forEach(event2 => {
            if (event1.filmId !== event2.filmId && event1.end < event2.start && (parseInt(vm.maxBreak) === 0 || (event2.start - event1.end) < parseInt(vm.maxBreak))) {
              let ignore = false
              vm.timeConstraints.forEach(constraint => {
                if (constraint.type === 0) {
                  console.log(event1.start)
                  console.log(this.hourToMins(constraint.start))
                  console.log(this.hourToMins(constraint.end))
                  if (constraint.end !== '23:59') {
                    if (event1.start > this.hourToMins(constraint.end)) {
                      ignore = true
                      console.log(1)
                    }
                  }
                  if (constraint.start !== '00:00') {
                    if (event1.start < this.hourToMins(constraint.start)) {
                      ignore = true
                      console.log(2)
                    }
                  }
                }
                if (constraint.type === 1) {
                  if (constraint.end !== '23:59') {
                    if (event2.end > this.hourToMins(constraint.end)) {
                      ignore = true
                    }
                  }
                  if (constraint.start !== '00:00') {
                    if (event2.end < this.hourToMins(constraint.start)) {
                      ignore = true
                    }
                  }
                }
              })
              if (!ignore) {
                if (required.length > 0) {
                  if (!required.includes(event1.filmId) && !required.includes(event2.filmId)) {
                    console.log('missing required')
                    ignore = true
                  }
                }
              }
              if (!ignore) {
                pairs.push({ event1: event1, event2: event2 })
              }
            }
          })
        })
      }
      pairs.forEach(pair => {
        if (this.moviesNumber === 1) {
          pair.movieBreak = 0
        } else {
          pair.movieBreak = pair.event2.start - pair.event1.end
        }
      })
      pairs.sort(sortPair)
      vm.result = pairs
      vm.titles = titles
      console.log(pairs)
    },
    calcDateToMins: function (date) {
      const datetime = new Date(date)
      return datetime.getHours() * 60 + datetime.getMinutes()
    },
    minsToHour: function (mins) {
      let m = mins % 60
      if (m < 10) {
        m = '0' + m
      }
      let h = (mins - (mins % 60)) / 60
      if (h < 10) {
        h = '0' + h
      }
      return h + ':' + m
    },
    hourToMins: function (hours) {
      const array = hours.split(':')

      return parseInt(array[0]) * 60 + parseInt(array[1])
    },
    updateDate (date) {
      this.date = date
    }
  }
}
</script>
